/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router";

import { Layout, HydrateFallback, LayoutErrorBoundary } from "./Layout";

import Home from "./Home/Home";
import Travel from "./Travel/Travel";
import Photos from "./Photos/Photos";
import ThingsToDo from "./ThingsToDo/ThingsToDo";

function start() {
  const root = createRoot(document.getElementById("root")!);
  let router = createBrowserRouter([
    {
      Component: Layout,
      HydrateFallback: HydrateFallback,
      ErrorBoundary: LayoutErrorBoundary,
      children: [
        {
          index: true,
          Component: Home,
        },
        {
          path: "travel",
          Component: Travel,
        },
        {
          path: "thingstodo",
          Component: ThingsToDo,
        },
        {
          path: "photos",
          Component: Photos,
          loader: () => fetch('/api/getpics'),
        }
      ],
    },
  ]);
  root.render(
    <RouterProvider router={router} />,
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
